module.exports = __webpack_public_path__ + "static/media/espiga_manitoba.b9971189.png";